import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from './MarketingLayout';

/**
 * Shared shell for public legal / policy pages.
 * content: {
 *   eyebrow, title, updated,
 *   intro?: string[],
 *   sections: [{ heading, paragraphs?, lists?: string[], subSections?: [{ heading, paragraphs?, lists? }] }],
 *   contact?: { name, website, websiteUrl, email, phone, address }
 * }
 */
function renderParagraphs(paragraphs = []) {
  return paragraphs.map((text, i) => (
    <p key={`${i}-${String(text).slice(0, 32)}`}>{text}</p>
  ));
}

function renderList(items) {
  if (!items?.length) return null;
  return (
    <ul className="mk-legal-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export default function LegalPage({ content }) {
  if (!content) return null;

  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <span className="mk-eyebrow">{content.eyebrow}</span>
          <h1>{content.title}</h1>
          <p>Last Updated: {content.updated}</p>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container mk-legal-prose">
          {content.intro?.length
            ? content.intro.map((text, i) => (
                <p key={`intro-${i}`} className={i === 0 ? 'mk-legal-lead' : undefined}>
                  {text}
                </p>
              ))
            : null}

          {content.sections.map((section) => (
            <div key={section.heading} className="mk-legal-block">
              <h2>{section.heading}</h2>
              {renderParagraphs(section.paragraphs)}
              {renderList(section.lists)}
              {renderParagraphs(section.afterLists)}
              {section.subSections?.map((sub) => (
                <div key={sub.heading || sub.paragraphs?.[0]?.slice(0, 24)} className="mk-legal-sub">
                  {sub.heading ? <h3>{sub.heading}</h3> : null}
                  {renderParagraphs(sub.paragraphs)}
                  {renderList(sub.lists)}
                </div>
              ))}
            </div>
          ))}

          {content.contact ? (
            <div className="mk-legal-block mk-legal-contact">
              <h2>{content.contact.heading || 'Contact Us'}</h2>
              {content.contact.lead ? <p>{content.contact.lead}</p> : null}
              <p>
                <strong>{content.contact.name}</strong>
              </p>
              <ul className="mk-legal-list mk-legal-contact-list">
                {content.contact.websiteUrl ? (
                  <li>
                    Website:{' '}
                    <a href={content.contact.websiteUrl} target="_blank" rel="noreferrer">
                      {content.contact.website}
                    </a>
                  </li>
                ) : null}
                {content.contact.email ? (
                  <li>
                    Email:{' '}
                    <a href={`mailto:${content.contact.email}`}>{content.contact.email}</a>
                  </li>
                ) : null}
                {content.contact.phone ? <li>Phone: {content.contact.phone}</li> : null}
                {content.contact.address ? <li>Office Address: {content.contact.address}</li> : null}
              </ul>
            </div>
          ) : null}

          <div className="mk-inline-actions" style={{ marginTop: 36 }}>
            <Link to="/contact" className="mk-btn mk-btn-primary">
              Contact us
            </Link>
            <Link to="/terms-and-conditions" className="mk-btn mk-btn-secondary">
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
